// extracted by mini-css-extract-plugin
module.exports = {"w1tcyud1":"w1tcyud1","w1rmz4w4":"w1rmz4w4"};